export const TOPIC_TYPE = {
  NORMAL: 1,
  FREE_TALK: 2,
};
export const TOPIC_TYPE_OPTIONS = Object.entries(TOPIC_TYPE).map(([key, value]) => {
  return { value, text: key };
});

